// extracted by mini-css-extract-plugin
export default {"mobile_menu":"Navbar_mobile_menu__uE+3k","mobileMenu_active":"Navbar_mobileMenu_active__wckQU"};